
import "./App.css";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import SmoothScrollWrapper from "./components/SmoothScrollWrapper";
import TopScroll from "./components/TopScroll";
import { Routes, Route } from "react-router-dom";
import AboutPage from "./pages/AboutPage";
import HomePage from "./pages/HomePage";
import CamundaPage from "./pages/Capabilities/CamundaPage";
import ContactUs from "./pages/ContactUs";
import PriorHealthcare from "./pages/Industries/PriorHealthcare";
import BlogPage from "./pages/BlogPage";
import BlogDetail from "./components/Blog/BlogDetails";
import CaseStudyPage from "./pages/CaseStudyPage";
import CaseStudyDetails from "./components/Casestudy/CaseStudyDetails";
import EventPage from "./pages/EventPage";
function App() {
  return (
    <SmoothScrollWrapper>
      <div className="App selection:bg-[#5fc9f0]/50">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route path="/case-studies" element={<CaseStudyPage />} />
          <Route path="/case-studies/:slug" element={<CaseStudyDetails />} />
          <Route path="/events" element={<EventPage />} />
          <Route path="/capabilities/camunda" element={<CamundaPage />} />
          <Route path="/industries/healthcare/prior-auth" element={<PriorHealthcare />} />
        </Routes>
        <Footer />
      </div>
      <TopScroll />
    </SmoothScrollWrapper>
  );
}

export default App;
